module.exports = __webpack_public_path__ + "img/measuring.a84628fb.png";